<template>
  <div class="input-v2">
    <div class="input-icon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 16C13.7614 16 16 13.7614 16 11C16 8.23858 13.7614 6 11 6C8.23858 6 6 8.23858 6 11C6 13.7614 8.23858 16 11 16Z"
          stroke="#919EAB"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 19L15.1333 15.1333"
          stroke="#919EAB"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <input
      :placeholder="placeholder"
      :type="type || 'text'"
      required
      @input="handleChange"
      @keyup.enter="handleEnterKey()"
      :class="classes"
      v-if="!disabled || showInput"
      :oninvalid="oninvalid"
      oninput="setCustomValidity('')"
      :pattern="pattern"
      :minlength="minlength"
      :maxlength="maxlength"
      :value="value"
      :disabled="disabled"
    />
  </div>
</template>
<script>
import { reactive } from "@vue/composition-api";

export default {
  name: "Inputv2Search",
  props: {
    placeholder: String,
    type: String,
    required: Boolean,
    onChange: Function,
    disabled: Boolean,
    classes: String,
    value: String,
    maxlength: String,
    pattern: String,
    handleRightTextClick: Function,
    rightText: String,
    oninvalid: String,
    minlength: String,
    showInput: Boolean,
    hideRightText: Boolean,
    handleEnterKey: {
      type: Function,
      default: () => {}
    }
  },
  model: {
    event: "change",
  },
  setup() {
    const state = reactive({
      isPassword: true,
    });

    function handleChange({ target }) {
      this.$emit("change", target.value.trim());
    }

    return {
      state,
      handleChange,
    };
  },
};
</script>
<style lang="scss" scoped>
.input-v2 {
  position: relative;

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  input:disabled {
    background: rgba(13, 72, 64, 0.05) !important;
    color: #000;
  }

  .right-text {
    cursor: pointer;
  }

  input {
    height: 55px;
    width: 100%;
    padding: 16px 60px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000;
    outline: none;
    border: none;
    border-radius: 4px;
  }
}
.input-icon {
  position: absolute;
  bottom: 10px;
  left: 15px;
}
</style>
